import React, { useEffect, useState } from "react";
import { useAccountingReports } from "../../../contextjs/AccountingReportsContext";
import { Card, Table, Button, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useFinancialYear } from "../../../contextjs/FinancialYearContext";
import { useUser } from "../../../UserContext";
import { fetchStores } from "../../../api/api";

const IncomeStatementReport = () => {
    const { incomeStatementData, fetchIncomeStatement } = useAccountingReports();
    const { activeFY, loadingFY } = useFinancialYear();
    const { user } = useUser();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [stores, setStores] =useState([]);
    const [storeId, setStoreId] = useState("all");
    const navigate = useNavigate();
    const canFilterStore = Boolean(user?.is_superuser || user?.is_staff);

    const handleBack = () => {
        navigate(-1);
    }

    // const handleFetch = () => {
    //     fetchIncomeStatement(startDate, endDate, activeFY?.id);
    // }
    //
    // useEffect(() => {
    //     fetchIncomeStatement(startDate, endDate, activeFY.id);
    // }, [fetchIncomeStatement, startDate, endDate, activeFY]);

    useEffect(() => {
        if (!activeFY) return;

        fetchIncomeStatement(
            startDate || activeFY.start_date,
            endDate || activeFY.end_date,
            activeFY.id,
            canFilterStore ? storeId : undefined
        );
    }, [fetchIncomeStatement, startDate, endDate, activeFY, storeId, canFilterStore]);

    useEffect(() => {
        if (!canFilterStore) return;
        fetchStores()
            .then((data) => setStores(Array.isArray(data) ? data : (data?.results || [])))
            .catch((error) => console.error("Error loading stores", error));
    }, [canFilterStore]);

    if (loadingFY || !incomeStatementData) {
        return <p>Loading...</p>;
    }

    const { income, contra_revenue, net_revenue, expense, net_profit } = incomeStatementData;

    return (
        <div>
            <div className="back-button-container" >
                <Button variant="secondary" onClick={handleBack}>Back</Button>
            </div>
            <Card className="mt-4">
                <Card.Header className="text-center">
                    <h2>Income Statement</h2>
                    {startDate && endDate ? (
                        <p>For the period {startDate} to {endDate}</p>
                    ) : (
                        <p>As of {new Date().toLocaleDateString()}</p>
                    )}
                    {incomeStatementData?.scope && (
                        <p className="mb-0">{incomeStatementData.scope.effective_store_name}</p>
                    )}
                </Card.Header>
                <Card.Body>
                    <Form className="mb-3">
                        <Row className="align-items-end">
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="startDate">
                                    <Form.Label>Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={4} md={4} lg={3}>
                                <Form.Group controlId="endDate">
                                    <Form.Label>End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            {canFilterStore && (
                                <Col xs={12} sm={4} md={4} lg={3}>
                                    <Form.Group controlId="storeScope">
                                        <Form.Label>Store</Form.Label>
                                        <Form.Select
                                            value={storeId}
                                            onChange={(e) => setStoreId(e.target.value)}
                                        >
                                            <option value="all">All Stores</option>
                                            {stores.map((store) => (
                                                <option key={store.id} value={store.id}>
                                                    {store.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>
                    </Form>

                    {/*income statement table*/}
                    <Table bordered hover>
                        <thead>
                            <tr>
                                <th>Description</th>
                                <th className="text-right">Amount (KES)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/*income section*/}
                            <tr>
                                <td colSpan="2"><strong>Income</strong></td>
                            </tr>
                            {income.accounts.map((account, index) => (
                                <tr key={`income-${index}`}>
                                    <td>{account.account_name}</td>
                                    <td className="text-right">
                                        {parseFloat(account.balance).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td><strong>Total Income</strong></td>
                                <td className="text-right"><strong>{parseFloat(income.total).toLocaleString()}</strong></td>
                            </tr>
                            {/*contra revenue section*/}
                            <tr>
                                <td colSpan="2"><strong>Less: Contra Revenue</strong></td>
                            </tr>
                            {contra_revenue.accounts.map((account, index) => (
                                <tr key={`contra-revenue-${index}`}>
                                    <td>{account.account_name}</td>
                                    <td className="text-right">
                                        {parseFloat(account.balance).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td><strong>Total Contra Revenue</strong></td>
                                <td className="text-right"><strong>{parseFloat(contra_revenue.total).toLocaleString()}</strong></td>
                            </tr>

                            {/*net revenue section*/}
                            <tr>
                                <td><strong>Net Revenue</strong></td>
                                <td className="text-right"><strong>{net_revenue.toLocaleString()}</strong></td>
                            </tr>

                            {/*expenses section*/}
                            <tr>
                                <td colSpan="2"><strong>Expenses</strong></td>
                            </tr>
                            {expense.accounts.map((account, index) => (
                                <tr key={`expense-${index}`}>
                                    <td>{account.account_name}</td>
                                    <td className="text-right">
                                        {parseFloat(account.balance).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td><strong>Total Expenses</strong></td>
                                <td className="text-right"><strong>{parseFloat(expense.total).toLocaleString()}</strong></td>
                            </tr>
                            {/*net profit section*/}
                            <tr>
                                <td><strong>Net Profit</strong></td>
                                <td className="text-right"><strong>{net_profit.toLocaleString()}</strong></td>
                            </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
    );
};

export default IncomeStatementReport;